







































































































































import { Component, Vue, Inject } from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../../../lib/ajax';
import AbpBase from '../../../../lib/abpbase';
import Tools from '../../../../lib/tools';
import QuickTable from "../../../../components/table/table.vue";
import SelectDep from "../../../../components/select/selectDep.vue";
@Component({
	name:'personInfoManage',
	components: {
		QuickTable,
		SelectDep
	}
})
export default class PersonInfoManage extends AbpBase  {
    initData:any = {
    	showModal: false,		// 弹窗显示状态
    	formLoading: false,		// 表单提交状态
    	formEditID: null,
    	majorFields: [],		// 专业
    	sexData: [],			// 性别数据字典
    	educationData: [],		// 学历数据字典
    	searchData: {
    		OrganizationId: '',
    		Name: ''
    	},
    	columns: [
            {
            	title: '序号',
                type: 'index',
                fixed: 'left',
                width: 62,
                align: 'center'
            },
            {
                title: '姓名',
                key: 'name',
                fixed: 'left',
                width: 138
            },
            {
                title: '性别',
                key: 'sexDesc',
                width: 68
            },
            {
                title: '出生年月',
                key: 'birthday',
                width: 128,
                render: (h:any, params:any) => {
                	return h('span', Tools.formatDate(params.row.birthday));
                }
            },
            {
                title: '参加工作时间',
                key: 'workDt',
                width: 128,
                render: (h:any, params:any) => {
                	return h('span', Tools.formatDate(params.row.workDt));
                }
            },
            {
                title: '部门',
                key: 'depDisplayName',
                width: 108
            },
            {
                title: '最高学历',
                key: 'hEducationDesc',
                width: 98
            },
            {
                title: '毕业院校',
                key: 'hEducationSchool',
                width: 160
            },
            {
                title: '所学专业',
                key: 'majorFieldId1',
                width: 128,
                render: (h:any, params:any) => {
                	return h('span', params.row.majorField1 ? params.row.majorField1.majorFieldName : '')
                }
            },
            {
                title: '最高职称',
                key: 'hPosition',
                width: 128
            },
            {
                title: '职称专业',
                key: 'hPositionMajorField',
                width: 128
            },
            {
                title: '最高职称评定年月',
                key: 'hPositionDt',
                width: 142,
                render: (h:any, params:any) => {
                	return h('span', Tools.formatDate(params.row.hPositionDt));
                }
            },
            {
                title: '职业资格',
                key: 'vQualification',
                width: 128
            },
            {
                title: '职业资格评定年月',
                key: 'vQualificationDt',
                width: 142,
                render: (h:any, params:any) => {
                	return h('span', Tools.formatDate(params.row.vQualificationDt));
                }
            },
            {
                title: '操作',
                width: 130,
                fixed: 'right',
                render: (h:any, params:any) => {
                	return h('span', [
                		h('Button', {
                			props: {
                				type: 'success',
                				size: 'small'
                			},
							on: {
								click: () => {
									for(let k in this.formData) {
										this.formData[k] = params.row[k];
									}
									this.formData.userName = 'fill';
									this.formData.organizationId = params.row.depId;
									this.initData.formEditID = params.row.id;
									this.initData.showModal = true;
								}
							}
                		}, '编辑'),
                		h('Button', {
                			props: {
                				type: 'error',
                				size: 'small'
                			},
                			style: {
                				marginLeft: '10px'
                			},
							on: {
								click: () => {
									this.handleDelete(params.row.id);
								}
							}
                		}, '删除')
                	])
                }
            }
        ]
    }
    formData:any = {
    	userName: '',
		name: '',						// 名字
		sex: 0,							// 性别
		birthday: '',					// 出生年月
		workDt: '',						// 参加工作时间
		hEducation: 0,					// 最高学历
		hEducationSchool: '',			// 毕业院校
		majorFieldId1: 0,				// 所学专业
		hPosition: '',					// 最高职称
		hPositionMajorField: '',		// 职称专业
		hPositionDt: '',				// 最高职称评定年月
		vQualification: '',				// 职业资格
		vQualificationDt: '',			// 职业资格评定年月
		idCardNo: '',					// 身份证号
		phoneNumber: '',				// 电话号码
		foreignLanguageLevelFirst: '',	// 外语水平
		emailAddress: '',				// 邮箱地址
		organizationId: 0				// 所在部门
    }
    ruleValidate:any = {
    	userName: [
            { required: true, message: '请输入新增用户名', trigger: 'blur' }
        ],
    	name: [
            { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
    	organizationId: [
            { required: true, type: 'number', message: '请选择所在部门', trigger: 'change' }
        ]
    }
    // 初始化
    init() {
    	// 获取专业信息
    	this.$store.dispatch('project/GetAllMajorField').then(() => {
    		this.initData.majorFields = this.$store.state.project.majorFields;
    	})
    	// 查询数据字典
    	this.$store.dispatch('project/GetAllDictionary').then(() => {
    		// 学历
    		this.initData.educationData = this.$store.state.project.allDictionary[22].items.map((item:any) => {
    			return {
    				label: item.displayName,
    				value: item.id
    			}
    		});
    		// 性别
    		this.initData.sexData = this.$store.state.project.allDictionary[7].items.map((item:any) => {
    			return {
    				label: item.displayName,
    				value: item.id
    			}
    		});
    	})
    }
    GetData() {
        (this as any).$refs.table.GetData();
    }
    // 新增
    async handleSubmit() {
    	(this.$refs.form as any).validate(async (valid:boolean)=>{
            if(valid){
            	let params:any = {};
            	for(let k in this.formData) {
            		if(k == 'workDt' || k == 'vQualificationDt' || k == 'hPositionDt' || k == 'birthday') {
            			params[k] = Tools.formatDate(this.formData[k]);
            		}else{
            			params[k] = this.formData[k];
            		}
            	}
            	
            	this.initData.formLoading = true;
            	if(this.initData.formEditID != null){
            		// 编辑
            		delete params.userName;
            		params.id = this.initData.formEditID;
            		await Ajax.put('/api/services/app/User/UpdatePersonAsync', params).then((res:any)=>{
		                this.$Message.success('编辑成功!');
		                this.initData.formLoading = false;
		                this.initData.showModal = false;
	                	this.GetData();
		            }).catch(() => {
		            	this.initData.formLoading = false;
		            })
            	}else{
            		// 添加
            		await Ajax.post('/api/services/app/User/CreatePersonAsync', params).then((res:any)=>{
		                this.$Message.success('提交成功!');
		                this.initData.formLoading = false;
		                this.initData.showModal = false;
	                	this.GetData();
		            }).catch(() => {
		            	this.initData.formLoading = false;
		            })
            	}
            }
        })
    }
    async handleDelete(id:any) {
    	this.$Modal.confirm({
            title: '操作确认',
            content: '是否确认删除此人员信息？',
            onOk: () => {
                Ajax.delete('/api/services/app/User/DeletePersonAsync', {params: {Id: id}}).then((res:any)=>{
	                this.$Message.success('删除成功!');
                	this.GetData();
	            })
            }
        });
    }
    handleClearForm(flog:any) {
    	if(!flog) {
    		this.initData.showModal = false;
    		this.initData.formEditID = null;
    		(this as any).$refs.form.resetFields();
    	}
    }
    async mounted() {
    	
    	this.init();
    	
    }
}
